import React from 'react';
import {  Row, Col } from 'reactstrap';
import PropTypes from 'prop-types'
import BackButton from './BackButton'

function getUnionLogo(unionid) {
  if (unionid) {
    const unionidLower = unionid.toLowerCase();
    return (<img className="UnionLogo img-fluid  float-md-left" src={`/img/${unionidLower}logo.png`} alt={"logo " + unionid} />);
   }
}

function getClubLogo(clubLogo, clubName) {
  if (clubLogo) {
     return (<img className="ClubLogo img-fluid float-md-right" src={clubLogo} alt={"logo " + clubName} />);
   }
}

const RegistrationHeader = (props) =>

  <Row>
    <Col md={{ size: 10,offset: 1 }} className="RegistrationHeader" >

      <div>
        <Row>
          <Col sm={{size:3}} >
            {getUnionLogo(props.unionid)}
          </Col>
          <Col sm={6}>
            <h1 className="TextCenter">
              {props.clubName ? `Aanmelden bij ${props.clubName}` : ''}
            </h1>
            <div>
              <p className="TextCenter" >{props.clubCity ? props.clubCity : ''}</p>
              {props.unionid !== 'KNVB' ? <BackButton /> : <div /> }

            </div>
          </Col>
          <Col sm={{size:3}} >
            {getClubLogo(props.clubLogo, props.clubName)}
          </Col>
        </Row>
      </div>
  </Col>
</Row>;

RegistrationHeader.propTypes = {
  clubLogo: PropTypes.string,
  clubName: PropTypes.string,
  unionid: PropTypes.string,
}

export default RegistrationHeader



// WEBPACK FOOTER //
// ./src/registration/RegistrationHeader.jsx